import { useEffect, useState } from "react";
import { useFetch } from "../../../custom/api";
import "../../../styles/Challenges.css";

function ChallengeCompletionCard({ challengeId, participation }) {
  const { myFetch } = useFetch();
  const [myRank, setMyRank] = useState(null);

  useEffect(() => {
    let ignore = false;
    const fetchRank = async () => {
      const resp = await myFetch(`challenges/${challengeId}/leaderboard`, {
        method: "GET",
      });
      const r = await resp.json();
      if (!ignore) setMyRank(r?.my_rank || null);
    };
    fetchRank();
    return () => {
      ignore = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [challengeId]);

  return (
    <div className="challengeProgressCard centerd centerAlign marginTop5">
      <p className="heading-2">چالش رو کامل کردی 🎉</p>
      <div className="spc-between width100 marginTop5">
        <div className="centerd">
          <p className="heading-1 purple-1">{participation.points}</p>
          <p className="caption-1 grey-2">امتیاز نهایی</p>
        </div>
        <div className="centerd">
          <p className="heading-1 purple-1">{participation.completed_days}</p>
          <p className="caption-1 grey-2">روز تکمیل‌شده</p>
        </div>
        <div className="centerd">
          <p className="heading-1 purple-1">
            {Math.round(participation.completion_percentage)}٪
          </p>
          <p className="caption-1 grey-2">درصد تکمیل</p>
        </div>
        {myRank && (
          <div className="centerd">
            <p className="heading-1 purple-1">{myRank.rank}</p>
            <p className="caption-1 grey-2">رتبه نهایی</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChallengeCompletionCard;
